import { BehaviorSubject } from "rxjs";

export type Role =
  | 'CallCenterAgent'
  | 'ScheduleCaptains'
  | 'CallCenterManager'
  | 'InsideSales'
  | 'SalesManager'
  | 'SuperUser'
  | 'Cfo'
  | 'VpOfOperations'
  | 'FieldSupport'
  | 'ServiceManager';

export const GROUP_ID_TO_ROLE: Record<string, Role> = {
  '2a136235-9001-4cc0-969e-0bc8c11dfcf9': 'CallCenterAgent', // not setup
  'c5358797-986e-4d08-aa24-0d24b18ae32d': 'ScheduleCaptains',
  '167c7dcb-89f9-49f5-85df-57ee323e061e': 'CallCenterManager', //not setup - Leads and Managers
  'f5d23c78-2590-4922-89d7-ebe8cf1c0f51': 'InsideSales',
  'a9bbce61-fdf3-4a9c-9f89-e182f80c752a': 'SalesManager',
  '4c885c05-73f1-4cab-b582-c9bd16edd451': 'SuperUser',
  'dc1cbb3f-bb8f-4fd0-81f6-c7a6b837a8db': 'Cfo',
  'b7350296-680f-47e7-829c-06f92cc8f171': 'VpOfOperations',
  '6529a5c0-bba6-4256-9a05-446ef75090a8': 'FieldSupport',
  '974101f4-44d7-4301-a4b5-dbde21ffb167': 'ServiceManager'
};

export const initialUserRoles: Record<Role, boolean> = {
  CallCenterAgent: false,
  ScheduleCaptains: false,
  CallCenterManager: false,
  InsideSales: false,
  SalesManager: false,
  SuperUser: false,
  Cfo: false,
  VpOfOperations: false,
  FieldSupport: false,
  ServiceManager: false
};

// Writer roles — mirror of backend AuthorizationGroups.Writers. Fail closed: a new role
// gets NO write access until explicitly added here.
export const WRITER_ROLES: readonly Role[] = [
  'CallCenterAgent',
  'ScheduleCaptains',
  'CallCenterManager',
  'InsideSales',
  'SalesManager',
  'SuperUser',
  'FieldSupport',
  'ServiceManager'
];

export const hasWriteAccess = (roles: Record<Role, boolean>): boolean =>
  WRITER_ROLES.some((role) => roles[role]);

export const userRoles$ = new BehaviorSubject<Record<Role, boolean>>(initialUserRoles);

export const observeUserRoles$ = () => {
  return userRoles$.asObservable();
};

export const getUserRoles = () => {
  return userRoles$.getValue();
};

export const setUserRole = (role: Role, value: boolean) => {
  const currentRoles = userRoles$.getValue();
  userRoles$.next({ ...currentRoles, [role]: value });
};

export const resetUserRoles = () => {
  userRoles$.next(initialUserRoles);
};
